/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.placementTest === "undefined") {
        jQuery.extend(sm.portal.vm, { placementTest: {} });
    }

    /**************************************/
    // ACT View Model
    // Holds the ACT Scores
    /**************************************/
    function ACTViewModel(options) {
        var defaults = {
            PlacementTestType: 'ACT',
            ID: 0,
            TestDate: null,
            Math: 0,
            English: 0,
            Reading: 0,
            Science: 0,
            Composite: 0,
            UsageMech: null,
            RhetSkills: null,
            PreAlgEleAlg: null,
            AlgCooGeo: null,
            PlaneGeoTrig: null,
            SocStuSci: null,
            ArtLit: null,
            Mode: 'Add',
            Index: 0
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PlacementTestType = ko.observable(settings.PlacementTestType);
        this.Index = ko.observable(settings.Index);
        this.ID = ko.observable(settings.ID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Math = ko.validatedObservable(settings.Math);
        this.English = ko.validatedObservable(settings.English);
        this.Reading = ko.validatedObservable(settings.Reading);
        this.Science = ko.validatedObservable(settings.Science);
        this.Composite = ko.validatedObservable(settings.Composite);
        this.UsageMech = ko.validatedObservable(settings.UsageMech);
        this.RhetSkills = ko.validatedObservable(settings.RhetSkills);
        this.PreAlgEleAlg = ko.validatedObservable(settings.PreAlgEleAlg);
        this.AlgCooGeo = ko.validatedObservable(settings.AlgCooGeo);
        this.PlaneGeoTrig = ko.validatedObservable(settings.PlaneGeoTrig);
        this.SocStuSci = ko.validatedObservable(settings.SocStuSci);
        this.ArtLit = ko.validatedObservable(settings.ArtLit);
    
        // add/edit mode
        this.Mode = ko.observable(settings.Mode);

        /*** TEST PROPERTIES ***/
        this.Touched = ko.observable(false);
        this.Clone = function () {
            return new sm.portal.vm.placementTest.ACTViewModel({
                ID: this.ID(),
                TestDate: this.TestDate(),
                Math: this.Math(),
                English: this.English(),
                Reading: this.Reading(),
                Science: this.Science(),
                Composite: this.Composite(),
                UsageMech: this.UsageMech(),
                RhetSkills: this.RhetSkills(),
                PreAlgEleAlg: this.PreAlgEleAlg(),
                AlgCooGeo: this.AlgCooGeo(),
                PlaneGeoTrig: this.PlaneGeoTrig(),
                SocStuSci: this.SocStuSci(),
                ArtLit: this.ArtLit(),
                Mode: this.Mode(),
                Index: this.Index()
            });
        };
        this.Copy = function (data) {
            return new sm.portal.vm.placementTest.ACTViewModel({
                ID: data.ID(),
                TestDate: data.TestDate(),
                Math: data.Math(),
                English: data.English(),
                Reading: data.Reading(),
                Science: data.Science(),
                Composite: data.Composite(),
                UsageMech: data.UsageMech(),
                RhetSkills: data.RhetSkills(),
                PreAlgEleAlg: data.PreAlgEleAlg(),
                AlgCooGeo: data.AlgCooGeo(),
                PlaneGeoTrig: data.PlaneGeoTrig(),
                SocStuSci: data.SocStuSci(),
                ArtLit: data.ArtLit(),
                Mode: data.Mode(),
                Index: data.Index()
            });
        };
        this.Clear = function () {
            this.ID('');
            this.TestDate('');
            this.Math('');
            this.English('');
            this.Reading('');
            this.Science('');
            this.Composite('');
            this.UsageMech('');
            this.RhetSkills('');
            this.PreAlgEleAlg('');
            this.AlgCooGeo('');
            this.PlaneGeoTrig('');
            this.SocStuSci('');
            this.ArtLit('');
            this.Index(0);
	        this.Mode('Add');
        };    
        /*** TEST PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.ScoreSummary = ko.computed(function () {
            var MathSubscores = '';
            var EnglishSubscores = '';
            var ReadingSubscores = '';

            // Math subscrores
            if (!sm.portal.utility.isNullOrEmpty(this.UsageMech()) || !sm.portal.utility.isNullOrEmpty(this.RhetSkills())) {
                MathSubscores = ', ' + sm.portal.utility.getResourceValue('EnglishSubScores') + ' (';
                if (!sm.portal.utility.isNullOrEmpty(this.UsageMech())) {
                    MathSubscores += sm.portal.utility.getResourceValue('UsageAndMechanics') + ': ' + this.UsageMech();
                }
                if (!sm.portal.utility.isNullOrEmpty(this.RhetSkills())) {
                    MathSubscores += sm.portal.utility.getResourceValue('RhetoricalSkills') + ': ' + this.RhetSkills();
                }
                MathSubscores += ")"
            }

            // English subscrores
            if (!sm.portal.utility.isNullOrEmpty(this.PreAlgEleAlg()) || !sm.portal.utility.isNullOrEmpty(this.AlgCooGeo()) || !sm.portal.utility.isNullOrEmpty(this.PlaneGeoTrig())) {
                EnglishSubscores = ', ' + sm.portal.utility.getResourceValue('MathSubScores') + ' (';
                if (!sm.portal.utility.isNullOrEmpty(this.PreAlgEleAlg())) {
                    EnglishSubscores += sm.portal.utility.getResourceValue('PreAndElementaryAlgebra') + ': ' + this.PreAlgEleAlg();
                }
                if (!sm.portal.utility.isNullOrEmpty(this.AlgCooGeo())) {
                    EnglishSubscores += sm.portal.utility.getResourceValue('AlgebraAndCoordGeometry') + ': ' + this.AlgCooGeo();
                }
                if (!sm.portal.utility.isNullOrEmpty(this.PlaneGeoTrig())) {
                    EnglishSubscores += sm.portal.utility.getResourceValue('PlaneGeometryAndTrig') + ': ' + this.PlaneGeoTrig();
                }
                EnglishSubscores += ")"
            }

            // Reading subscrores
            if (!sm.portal.utility.isNullOrEmpty(this.SocStuSci()) || !sm.portal.utility.isNullOrEmpty(this.ArtLit())) {
                ReadingSubscores = ', ' + sm.portal.utility.getResourceValue('ReadingSubScores') + ' (';
                if (!sm.portal.utility.isNullOrEmpty(this.SocStuSci())) {
                    ReadingSubscores += sm.portal.utility.getResourceValue('SocialStudiesAndSciences') + ': ' + this.SocStuSci();
                }
                if (!sm.portal.utility.isNullOrEmpty(this.ArtLit())) {
                    ReadingSubscores += sm.portal.utility.getResourceValue('ArtsAndLiterature') + ': ' + this.ArtLit();
                }
                ReadingSubscores += ")"
            }

            return sm.portal.utility.getResourceValue('MathSubScores') + ': ' + this.Math() + MathSubscores +
                   ', ' + sm.portal.utility.getResourceValue('EnglishSubScores') + ': ' + this.English() + EnglishSubscores +
                   ', ' + sm.portal.utility.getResourceValue('ReadingSubScores') + ': ' + this.Reading() + ReadingSubscores +
                   ', ' + sm.portal.utility.getResourceValue('Science') + ': ' + this.Science() +
                   ', ' + sm.portal.utility.getResourceValue('Composite') + ': ' + this.Composite();
        }, this);
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(self.TestDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Math())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.English())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Reading())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Science())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Composite())) return true;

            return false;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION METHODS ***/
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new smapi.admissions.ACTModel({
                ID: self.ID(),
                TestDate: self.TestDate(),
                Math: self.Math(),
                English: self.English(),
                Reading: self.Reading(),
                Science: self.Science(),
                Composite: self.Composite(),
                UsageMech: self.UsageMech(),
                RhetSkills: self.RhetSkills(),
                PreAlgEleAlg: self.PreAlgEleAlg(),
                AlgCooGeo: self.AlgCooGeo(),
                PlaneGeoTrig: self.PlaneGeoTrig(),
                SocStuSci: self.SocStuSci(),
                ArtLit: self.ArtLit()
            });
        };
        /*** SECTION METHODS ***/

        /*** VALIDATION METHODS ***/
        this.TestDate.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Math.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 36,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '36')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.English.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 36,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '36')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Reading.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 36,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '36')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Science.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 36,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '36')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Composite.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterOrEqualThan0_Key), '0')
            },
            max: {
                params: 36,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessOrEqualThan0_Key), '36')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.UsageMech.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.RhetSkills.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PreAlgEleAlg.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AlgCooGeo.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.PlaneGeoTrig.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.SocStuSci.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.ArtLit.extend({
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 18,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '18')
            },
            digit: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm.placementTest, {
        ACTViewModel: ACTViewModel,
    });

})(jQuery);